// Mock data for gym management
export const gymService = {
  // Coaches
  coaches: [
    {
      id: 1,
      name: 'Juan Martínez',
      specialty: 'Entrenamiento Funcional',
      rating: 4.8,
      reviews: 24,
      assigned_members: 3,
      bio: 'Entrenador certificado con 10 años de experiencia'
    },
    {
      id: 2,
      name: 'Sofia García',
      specialty: 'Musculación y Fitness',
      rating: 4.6,
      reviews: 18,
      assigned_members: 2,
      bio: 'Especialista en ganancia muscular y nutrición'
    },
    {
      id: 3,
      name: 'Luis Hernández',
      specialty: 'Yoga y Pilates',
      rating: 4.9,
      reviews: 32,
      assigned_members: 1,
      bio: 'Certificado en Yoga y Pilates clínico'
    }
  ],

  // Rutinas de Ejercicio
  routines: [
    {
      id: 1,
      name: 'Rutina de Pecho y Tríceps',
      description: 'Enfocada en fuerza y volumen del pecho',
      coach_id: 1,
      created_date: '2025-08-01',
      exercises: [
        {
          id: 1,
          name: 'Press de Banca',
          description: 'Ejercicio fundamental para pecho',
          series: 4,
          reps: 8,
          weight: '80 kg',
          restTime: '2 min',
          notes: 'Controlar la bajada, evitar rebote'
        },
        {
          id: 2,
          name: 'Aperturas de Pecho (Mancuernas)',
          description: 'Aislamiento de pecho',
          series: 3,
          reps: 10,
          weight: '30 kg',
          restTime: '1.5 min',
          notes: 'Rango completo de movimiento'
        },
        {
          id: 3,
          name: 'Extensiones de Tríceps',
          description: 'Trabajo de tríceps',
          series: 3,
          reps: 12,
          weight: '40 kg',
          restTime: '1 min',
          notes: 'Codos fijos en posición'
        }
      ]
    },
    {
      id: 2,
      name: 'Rutina de Espalda y Bíceps',
      description: 'Trabajo de espalda completo y brazos',
      coach_id: 1,
      created_date: '2025-08-05',
      exercises: [
        {
          id: 4,
          name: 'Dominadas',
          description: 'Ejercicio compuesto de espalda',
          series: 4,
          reps: 8,
          weight: 'Peso corporal',
          restTime: '2 min',
          notes: 'Agarre neutral o pronación'
        },
        {
          id: 5,
          name: 'Remo con Barra',
          description: 'Trabajo de espalda media',
          series: 4,
          reps: 8,
          weight: '100 kg',
          restTime: '2 min',
          notes: 'Espalda recta, retracción escapular'
        },
        {
          id: 6,
          name: 'Flexiones de Bíceps',
          description: 'Aislamiento de bíceps',
          series: 3,
          reps: 10,
          weight: '15 kg',
          restTime: '1 min',
          notes: 'Movimiento controlado'
        }
      ]
    },
    {
      id: 3,
      name: 'Rutina de Piernas',
      description: 'Trabajo completo de miembros inferiores',
      coach_id: 2,
      created_date: '2025-07-20',
      exercises: [
        {
          id: 7,
          name: 'Sentadillas',
          description: 'Ejercicio fundamental para piernas',
          series: 4,
          reps: 6,
          weight: '120 kg',
          restTime: '3 min',
          notes: 'Profundidad máxima, espalda recta'
        },
        {
          id: 8,
          name: 'Prensa de Piernas',
          description: 'Complemento de sentadillas',
          series: 3,
          reps: 10,
          weight: '200 kg',
          restTime: '2 min',
          notes: 'No bloquear rodillas'
        },
        {
          id: 9,
          name: 'Curl de Isquiotibiales',
          description: 'Trabajo específico de isquiotibiales',
          series: 3,
          reps: 12,
          weight: '60 kg',
          restTime: '1 min',
          notes: 'Contracción máxima en cada rep'
        }
      ]
    },
    {
      id: 4,
      name: 'Yoga Básico',
      description: 'Rutina de yoga para flexibilidad y relajación',
      coach_id: 3,
      created_date: '2025-08-10',
      exercises: [
        {
          id: 10,
          name: 'Saludos al Sol',
          description: 'Secuencia de calentamiento',
          series: 5,
          reps: 1,
          weight: 'Sin peso',
          restTime: '30 seg',
          notes: 'Respiración profunda durante la secuencia'
        },
        {
          id: 11,
          name: 'Flexión Hacia Adelante',
          description: 'Estiramiento de isquiotibiales',
          series: 1,
          reps: 3,
          weight: 'Sin peso',
          restTime: '1 min',
          notes: 'Mantener 30 segundos cada repetición'
        },
        {
          id: 12,
          name: 'Postura del Loto',
          description: 'Estiramiento de caderas',
          series: 1,
          reps: 2,
          weight: 'Sin peso',
          restTime: '1.5 min',
          notes: 'Mantener 45 segundos cada lado'
        }
      ]
    }
  ],

  // Members
  members: [
    { id: 1, name: 'Carlos García López', phone: '555-1234' },
    { id: 2, name: 'María Rodríguez López', phone: '555-5678' },
    { id: 3, name: 'Roberto Díaz Sánchez', phone: '555-9012' },
    { id: 4, name: 'Fernando Ruiz González', phone: '555-3456' },
    { id: 5, name: 'Miguel Sánchez Ruiz', phone: '555-7890' }
  ],

  // Asignaciones de Rutinas a Socios
  routineAssignments: [
    {
      id: 1,
      member_id: 1,
      routine_id: 1,
      coach_id: 1,
      status: 'activa',
      start_date: '2025-08-01',
      end_date: null,
      exercises_completed: [1, 2]
    },
    {
      id: 2,
      member_id: 2,
      routine_id: 2,
      coach_id: 1,
      status: 'activa',
      start_date: '2025-07-15',
      end_date: null,
      exercises_completed: [4, 5]
    },
    {
      id: 3,
      member_id: 3,
      routine_id: 3,
      coach_id: 2,
      status: 'pausada',
      start_date: '2025-06-20',
      end_date: null,
      exercises_completed: [7]
    }
  ],

  // Historial de cambios
  history: [
    {
      id: 1,
      member_name: 'Carlos García López',
      date: '2025-08-10',
      time: '10:30',
      action: 'asignacion',
      details: 'Rutina asignada: Pecho y Tríceps'
    },
    {
      id: 2,
      member_name: 'María Rodríguez López',
      date: '2025-08-08',
      time: '14:15',
      action: 'modificacion',
      details: 'Cambio de rutina a Espalda y Bíceps'
    },
    {
      id: 3,
      member_name: 'Roberto Díaz Sánchez',
      date: '2025-08-05',
      time: '09:45',
      action: 'pausa',
      details: 'Rutina pausada por recomendación médica'
    }
  ],

  // Helpers
  getRoutineById (id) {
    return this.routines.find(r => r.id === id)
  },

  getMemberById (id) {
    return this.members.find(m => m.id === id)
  },

  getCoachById (id) {
    return this.coaches.find(c => c.id === id)
  },

  getCoachRoutines (coachId) {
    return this.routines.filter(r => r.coach_id === coachId)
  },

  getMemberAssignments (memberId) {
    return this.routineAssignments.filter(a => a.member_id === memberId)
  },

  getAssignmentById (id) {
    return this.routineAssignments.find(a => a.id === id)
  },

  createRoutine (name, description, coachId) {
    const newRoutine = {
      id: Math.max(...this.routines.map(r => r.id), 0) + 1,
      name,
      description,
      coach_id: coachId,
      created_date: new Date().toISOString().split('T')[0],
      exercises: []
    }
    this.routines.push(newRoutine)
    return newRoutine
  },

  addExerciseToRoutine (routineId, exercise) {
    const routine = this.getRoutineById(routineId)
    if (routine) {
      exercise.id = Math.max(...routine.exercises.map(e => e.id), 0) + 1
      routine.exercises.push(exercise)
      return exercise
    }
    return null
  },

  updateExercise (routineId, exerciseId, updatedExercise) {
    const routine = this.getRoutineById(routineId)
    if (routine) {
      const index = routine.exercises.findIndex(e => e.id === exerciseId)
      if (index > -1) {
        routine.exercises[index] = { ...routine.exercises[index], ...updatedExercise }
        return routine.exercises[index]
      }
    }
    return null
  },

  removeExerciseFromRoutine (routineId, exerciseId) {
    const routine = this.getRoutineById(routineId)
    if (routine) {
      routine.exercises = routine.exercises.filter(e => e.id !== exerciseId)
      return true
    }
    return false
  },

  assignRoutineToMember (memberId, routineId, coachId) {
    const newAssignment = {
      id: Math.max(...this.routineAssignments.map(a => a.id), 0) + 1,
      member_id: memberId,
      routine_id: routineId,
      coach_id: coachId,
      status: 'activa',
      start_date: new Date().toISOString().split('T')[0],
      end_date: null,
      exercises_completed: []
    }
    this.routineAssignments.push(newAssignment)
    return newAssignment
  },

  updateAssignmentStatus (assignmentId, status) {
    const assignment = this.getAssignmentById(assignmentId)
    if (assignment) {
      assignment.status = status
      if (status === 'completada') {
        assignment.end_date = new Date().toISOString().split('T')[0]
      }
      return assignment
    }
    return null
  },

  markExerciseAsCompleted (assignmentId, exerciseId) {
    const assignment = this.getAssignmentById(assignmentId)
    if (assignment && !assignment.exercises_completed.includes(exerciseId)) {
      assignment.exercises_completed.push(exerciseId)
      return true
    }
    return false
  }
}

export default gymService
